var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onboarding-page aepps"},[_c('img',{attrs:{"src":require("../../assets/onboarding/aepps.svg")}}),_c('Guide',[_c('em',[_vm._v(_vm._s(_vm.$t('onboarding.aepps.guide')))]),_c('div',{staticClass:"note"},[_vm._v(" "+_vm._s(_vm.$t('onboarding.aepps.note'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }